
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/headless/conversation-list",
      function () {
        return require("private-next-pages/x/react-chat/headless/conversation-list.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/headless/conversation-list"])
      });
    }
  